import React, { ReactElement } from 'react'
import { Collapse, UnmountClosed } from 'react-collapse'
import { observer } from 'mobx-react'

import * as Styled from './ExpandAndCollapse.styled'

interface Props {
   isOpened: boolean
   children: ReactElement
   shouldUnmountCollapsedComponent?: boolean
   containerClassName?: string
   collapseClassName?: string

   // Refer the package https://github.com/nkbt/react-collapse before adding any prop
}

const ExpandAndCollapse = (props: Props): ReactElement => {
   const {
      shouldUnmountCollapsedComponent = true,
      containerClassName,
      collapseClassName,
      children,
      ...otherProps
   } = props
   return (
      <Styled.ExpandableAndCollapseContainer
         className={containerClassName}
         collapseClassName={collapseClassName}
      >
         {shouldUnmountCollapsedComponent ? (
            <UnmountClosed {...otherProps}>{children}</UnmountClosed>
         ) : (
            <Collapse {...otherProps}>{children}</Collapse>
         )}
      </Styled.ExpandableAndCollapseContainer>
   )
}

export default observer(ExpandAndCollapse)
